import { useState, useEffect } from "react";
import SubHeader from "components/common/SubHeader";
import Blank from "components/common/Blank";
import useUserStore from "@store/useUserStore";
import Postcode from "components/common/Postcode";
import CommonModal from "components/common/CommonModal";
import {
    getUserAddressList,
    createUserAddressList,
    updateUserAddressList,
} from "api/user";
import { AddressCard } from "./UserEdit";

const AddressEdit = () => {
    const userInfo = useUserStore((state) => state.userInfo);
    const setUserInfo = useUserStore((state) => state.setUserInfo);
    const [addressList, setAddressList] = useState([]);
    const [openAddAddress, setOpenAddAddress] = useState(false);

    useEffect(() => {
        getUserAddressList().then((res) => {
            if (res) setAddressList(res);
        });
    }, [openAddAddress]);

    return (
        <div className="page-user-edit">
            <SubHeader title="주소 관리" />
            <Blank height={57} />

            {addressList.length > 0 &&
                addressList.map((address) => (
                    <AddressCard
                        address={address}
                        key={address.id}
                        setAddressList={setAddressList}
                    />
                ))}

            {addressList.length < 3 && (
                <div className="address-card-wrap empty-address">
                    <p
                        className="empty-address-text"
                        onClick={() => setOpenAddAddress(true)}
                    >
                        + 주소 추가하기
                    </p>
                    <CommonModal
                        isOpen={openAddAddress}
                        onRequestClose={() => setOpenAddAddress(false)}
                        className={`address-modal-wrap`}
                    >
                        <Postcode
                            address={{
                                is_primary: addressList.length === 0,
                                id: null,
                            }}
                            saveAddress={(id, postcode, isPrimary) => {
                                if (id === null) {
                                    if (isPrimary) {
                                        const updatedAddressList =
                                            addressList.map((addr) => ({
                                                ...addr,
                                                is_primary: false,
                                            }));
                                        setAddressList(updatedAddressList);
                                    }

                                    createUserAddressList(postcode)
                                        .then((res) => {
                                            if (res) {
                                                if (isPrimary) {
                                                    const finalAddressList =
                                                        addressList.map(
                                                            (addr) => ({
                                                                ...addr,
                                                                is_primary: false,
                                                            })
                                                        );
                                                    setAddressList([
                                                        ...finalAddressList,
                                                        res,
                                                    ]);
                                                    setUserInfo({
                                                        ...userInfo,
                                                        addresses: [
                                                            ...userInfo.addresses,
                                                            res,
                                                        ],
                                                    });
                                                } else {
                                                    setAddressList([
                                                        ...addressList,
                                                        res,
                                                    ]);
                                                    setUserInfo({
                                                        ...userInfo,
                                                        addresses: [
                                                            ...userInfo.addresses,
                                                            res,
                                                        ],
                                                    });
                                                }
                                            }
                                        })
                                        .catch(() => {
                                            getUserAddressList().then((res) => {
                                                if (res) setAddressList(res);
                                            });
                                        });
                                }
                                setOpenAddAddress(false);
                            }}
                        />
                    </CommonModal>
                </div>
            )}
        </div>
    );
};

export default AddressEdit;
